// extracted by mini-css-extract-plugin
module.exports = {"Container":"pre-footer-links_Container__mFYqN","LinksContainer":"pre-footer-links_LinksContainer__DwAte"};